import React from "react";
import PropTypes from "prop-types";

import useClientCardIframeSync from "./hooks/useClientCardIframeSync";
import useClientCardIframeSyncOptions from "./hooks/useClientCardIframeSyncOptions";

export default function ClientCard({
  mapPathnameForIframeSrc,
  mapPathnameFromChild,
  initialPathnameOverride,
  syncEnabled,
}) {
  const syncOptions = useClientCardIframeSyncOptions({
    mapPathnameForIframeSrc,
    mapPathnameFromChild,
    initialPathnameOverride,
    syncEnabled,
  });

  const { iframeRef, iframeSrc, handleIframeLoad } =
    useClientCardIframeSync(syncOptions);

  return (
    <iframe
      ref={iframeRef}
      id="new-client-card-iframe"
      src={iframeSrc}
      title="New Client Card Content"
      style={{ border: "none", width: "100%", height: "100%" }}
      onLoad={handleIframeLoad}
    />
  );
}

ClientCard.propTypes = {
  mapPathnameForIframeSrc: PropTypes.func,
  mapPathnameFromChild: PropTypes.func,
  initialPathnameOverride: PropTypes.string,
  syncEnabled: PropTypes.bool,
};

ClientCard.defaultProps = {
  mapPathnameForIframeSrc: undefined,
  mapPathnameFromChild: undefined,
  initialPathnameOverride: undefined,
  syncEnabled: undefined,
};
